import type { Locale } from '@porotutu/i18n'
import { DataTable } from '@porotutu/react/components/DataTable/DataTable'
import { EmptyState } from '@porotutu/react/components/EmptyState/EmptyState'
import { FilterBar } from '@porotutu/react/components/FilterBar/FilterBar'
import { Pagination } from '@porotutu/react/components/Pagination/Pagination'
import { Panel } from '@porotutu/react/components/Panel/Panel'
import { useT } from '@porotutu/react/session'
import type { OrganizationListQuery, OrganizationPage } from '../queries'
import { columnsFor } from './columns'

export type OrganizationsListProps = {
  page: OrganizationPage
  query: OrganizationListQuery
  locale: Locale
  onQuery: (patch: Record<string, string | number | undefined>) => void
  onReset: () => void
}

export function OrganizationsList({
  page,
  query,
  locale,
  onQuery,
  onReset,
}: OrganizationsListProps) {
  const t = useT()
  const filtered = query.search !== undefined

  return (
    <Panel
      level={1}
      title={t('adm.organizations.index.heading')}
      subtitle={t('adm.organizations.index.subheading')}
    >
      <FilterBar
        search={query.search ?? ''}
        searchPlaceholder={t('adm.organizations.filters.search_placeholder')}
        selects={[]}
        onChange={(patch) => onQuery({ ...patch, offset: undefined })}
        onReset={onReset}
      />

      <DataTable
        id="organizations-list"
        columns={columnsFor(t, locale, query)}
        rows={page.data}
        rowKey={(row) => row.id}
        meta={page.meta}
        empty={
          <EmptyState>
            {filtered ? t('adm.organizations.filtered_empty') : t('adm.organizations.empty')}
          </EmptyState>
        }
      />

      <Pagination meta={page.meta} />
    </Panel>
  )
}
